import { adminServerInstance, deliveryServerInstance } from "../axios/instances";
import { WRONG_ADDRESS as type } from "./wrongAddressTypes";

/**
 * 
 */
export function getProvincesCovered(country) {   
    return function(dispatch) {
        dispatch({type: type.GET_PROVINCES_COVERED})
        return deliveryServerInstance.get(`/masterdata/provinces/${country}`)
        .then(({data}) => {
            dispatch({
                type: type.GET_PROVINCES_COVERED_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.GET_PROVINCES_COVERED_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.address
 * @param {string} params.postal_code
 */
 export function getAddress(params) {   
    return function(dispatch) {
        dispatch({type: type.GET_ADDRESS})
        return adminServerInstance.get(`/location/getaddress`, {params: params})
        .then(({data}) => {
            dispatch({
                type: type.GET_ADDRESS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_ADDRESS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.address
 * @param {string} params.postal_code
 */
export function addressAutocorrection(params) {   
    return function(dispatch) {
        dispatch({type: type.ADDRESS_AUTOCORRECTION})
        return adminServerInstance.get(`/location/addressautocorrection`, {params: params})
        .then(({data}) => {
            dispatch({
                type: type.ADDRESS_AUTOCORRECTION_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.ADDRESS_AUTOCORRECTION_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.address
 * @param {string} params.postal_code
 * @param {string} params.new_address
 * @param {string} params.new_postal_code
 * @param {string} params.lat
 * @param {string} params.lng
 * @param {string} params.street_number
 * @param {string} params.route
 * @param {string} params.area_level_2 - city
 * @param {string} params.area_level_1 - province
 * @param {string} params.country
 * @param {string} params.addr_type
 * @param {string} params.buzz_code
 * @param {string} params.unit_no
 * @param {string} params.operator
 */
export function updateOrCreateAddress(params) {   
    return function(dispatch) {
        dispatch({type: type.UPDATE_OR_CREATE_ADDRESS})
        return adminServerInstance.post(`/location/updateorcreateaddress`, params)
        .then(({data}) => {
            dispatch({
                type: type.UPDATE_OR_CREATE_ADDRESS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.UPDATE_OR_CREATE_ADDRESS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 */
export function getExistAddressTypes() {   
    return function(dispatch) {
        dispatch({type: type.GET_EXIST_ADDRESS_TYPES})
        return adminServerInstance.get(`/location/getexistaddresstypes`)
        .then(({data}) => {
            dispatch({
                type: type.GET_EXIST_ADDRESS_TYPES_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_EXIST_ADDRESS_TYPES_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 */
export function getDeliveryTypes() {   
    return function(dispatch) {
        dispatch({type: type.GET_DELIVERY_TYPES})
        return adminServerInstance.get(`/location/getdeliverytypes`)
        .then(({data}) => {
            dispatch({
                type: type.GET_DELIVERY_TYPES_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_DELIVERY_TYPES_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.driver_id
 * @param {string} params.batch_list
 * @param {string} params.warehouse
 * @param {string} params.delivery_type
 */
export function getServiceWrongAddress(params) {   
    return function(dispatch) {
        dispatch({type: type.GET_SERVICE_WRONG_ADDRESS})
        return adminServerInstance.get(`/location/getservicewrongaddress`, { params: params }, { timeout: 0 })
        .then(({data}) => {
            dispatch({
                type: type.GET_SERVICE_WRONG_ADDRESS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_SERVICE_WRONG_ADDRESS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.addresses
 */
export function batchVerifyAddresses(params) {   
    return function(dispatch) {
        dispatch({type: type.BATCH_VERIFY_ADDRESSES})
        return adminServerInstance.post(`/location/batchverifyaddresses`, params)
        .then(({data}) => {
            dispatch({
                type: type.BATCH_VERIFY_ADDRESSES_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.BATCH_VERIFY_ADDRESSES_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.addresses
 */
export function batchGeoWrongAddress(params) {   
    return function(dispatch) {
        dispatch({type: type.BATCH_GEO_WRONG_ADDRESS})
        return adminServerInstance.post(`/location/batchgeowrongaddress`, params)
        .then(({data}) => {
            dispatch({
                type: type.BATCH_GEO_WRONG_ADDRESS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.BATCH_GEO_WRONG_ADDRESS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.addresses
 */
export function batchCorrectServiceWrongAddress(params) {   
    return function(dispatch) {
        dispatch({type: type.BATCH_CORRECT_SERVICE_WRONG_ADDRESS})
        return adminServerInstance.post(`/location/batchcorrectservicewrongaddress`, params)
        .then(({data}) => {
            dispatch({
                type: type.BATCH_CORRECT_SERVICE_WRONG_ADDRESS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.BATCH_CORRECT_SERVICE_WRONG_ADDRESS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}